// extracted by mini-css-extract-plugin
export default {"modalHeader":"CustomPageOneModal_modalHeader__Ib4dU"};